<script setup lang="ts">
import HeaderServiceSection from '@/components/services/HeaderServiceSection.vue'
import PersonDescribeSection from '@/components/PersonDescribeSection.vue'
import SolutionSection from '@/components/services/SolutionSection.vue'
import { useCommonElementsStore } from '@/store/commonElements.store'
import TechnologyPanel from '@/components/panels/TechnologyPanel.vue'
import { useServiceStore } from '@/store/service.store'
import SideChanger from '@/components/SideChanger.vue'
import { Routes, RoutesName } from '@/enums/Routes'
import HeaderComponent from '@/components/HeaderComponent.vue'
import { ApplicationMode } from '@/enums/ApplicationMode'

useHead({
  title: 'Services with value-focused approach',
  meta: [
    {
      name: 'description',
      content:
        'We are digitalization consulting and software development partners. ' +
        'We can code, we can scale, we can design.',
    },
  ],
})

const store = useServiceStore()
const commonStore = useCommonElementsStore()
const sideChanger = store.getSideChanger

const prev = {
  title: sideChanger?.leftText ?? '',
  section: RoutesName.OUR_MODEL,
  route: Routes.OUR_MODEL,
}
const next = {
  title: sideChanger?.rightText ?? '',
  section: RoutesName.PORTFOLIO,
  route: Routes.PORTFOLIO,
}
</script>

<template>
  <div>
    <HeaderComponent
      v-if="store.getHeader"
      :background="store.getHeader.background"
      :describe="store.getHeader.copy"
      :title="store.getHeader.title"
      :mode="ApplicationMode.Short"
    />
    <SolutionSection
      v-if="store.getPanels && commonStore.getPanels"
      :panels="commonStore.getPanels"
      :panel-section="store.getPanels"
    />
    <TechnologyPanel
      v-if="store.getTechnologies && commonStore.getTechnologies"
      :technologies-section="store.getTechnologies"
      :technologies="commonStore.getTechnologies"
    />
    <div>
      <SideChanger v-if="sideChanger" :prev="prev" :next="next">
        <PersonDescribeSection
          :business-card="commonStore.getBusinessCard"
          v-if="commonStore.getBusinessCard"
        />
      </SideChanger>
    </div>
  </div>
</template>
